import { Reducer } from 'redux';
import {
  MsalState,
  MsalLoginActionTypes,
  MSAL_LOGIN_INPROGRESS,
  MSAL_LOGIN_SUCCESS,
  MSAL_LOGIN_FAILURE,
  MSAL_LOGOUT_SUCCESS,
} from './types';

const initialState: MsalState = {
  authenticated: false,
  isLoading: false,
  error: undefined,
};

const loginReducer: Reducer<MsalState> = (state = initialState, action: MsalLoginActionTypes): MsalState => {
  switch (action.type) {
    case MSAL_LOGIN_INPROGRESS:
      return {
        ...state,
        authenticated: false,
        isLoading: true,
        error: undefined,
      };
    case MSAL_LOGIN_SUCCESS:
      return {
        ...state,
        authenticated: true,
        isLoading: false,
        error: undefined,
      };
    case MSAL_LOGIN_FAILURE:
      return {
        ...state,
        authenticated: false,
        isLoading: false,
        error: action.payload.message,
      };
    case MSAL_LOGOUT_SUCCESS:
      return {
        ...state,
        authenticated: false,
        isLoading: false,
        error: undefined,
      };
    default:
      return state;
  }
};
export default loginReducer;
